export const getSourceText = (dictionary, key) => {
    if (key in dictionary) {
        const value = dictionary[key];
        return typeof value === 'string' ? value : getSourceText(value, key);
    }
    let index = key.indexOf('.', 0);
    while (index !== -1) {
        const subKey = key.substring(0, index);
        if (subKey in dictionary) {
            const value = dictionary[subKey];
            return typeof value === 'string' ? value : getSourceText(value, key.substring(index + 1));
        }
        index = key.indexOf('.', index);
    }
    return `Could not determine source text for key "${key}" in dictionary: ${JSON.stringify(dictionary)}`;
};
//# sourceMappingURL=getSourceText.js.map